import styled from '@emotion/styled';
import Button from '@mui/material/Button';
import { smallBold } from '../styles/typography';

const StyledButton = styled(Button)(({ theme }) => ({
  ...smallBold,
  borderRadius: "0",
  textTransform: "none",
  transition: "all 0.3s ease",
  padding: "3px 20px",
  marginRight: 0.5,
  "&:hover": {
    boxShadow: "2px 2px 4px rgba(0,0,0,0.1), -2px -2px 4px rgba(255,255,255,0.7)", // Reduced shadow spread
  },
}));

export default StyledButton;